import { Axios } from "../../utils/axiosMiddleware";

/**
 * Count the current contractor's connected GIGSTERS (G9 award guard). The award-to-
 * gigster flow opens a picker populated ONLY with the contractor's tradesman (gigster)
 * connections, so the guard must count the same thing — not every connection row. A
 * contractor↔contractor connection is NOT a gigster and must not pass the guard (else
 * the picker still shows "no gigsters"). This mirrors the sorting in `getConnections`
 * that feeds that picker: for a row where the contractor is a party, the counterparty
 * is a gigster only when the OTHER side's contractor id is absent (so it's a tradesman).
 *
 * Deliberately does NOT swallow errors — it lets the request reject so the caller can
 * fail CLOSED (award leads to a real charge and must not run on unverified data).
 */
export const getConnectionCount = async () => {
  const token = JSON.parse(localStorage.getItem("data"));
  const response = await Axios.get(
    `interactions/connections/${token?.id}/${token?.user_type}`
  );
  const rows = Array.isArray(response?.data) ? response.data : [];

  const isGigsterConnection = (item) => {
    if (item?.senderContractorId === token?.id) {
      // I sent it; it's a gigster only if the receiver is a tradesman (no contractor).
      return !item?.receiverContractorId && Boolean(item?.receiverTradesmanId);
    }
    if (item?.receiverContractorId === token?.id) {
      // I received it; gigster only if the sender is a tradesman (no contractor).
      return !item?.senderContractorId && Boolean(item?.senderTradesmanId);
    }
    return false;
  };

  return rows.reduce(
    (count, item) => (isGigsterConnection(item) ? count + 1 : count),
    0
  );
};
